class Accordion {
    /**
     * Constructor
     * @param accordion
     */
    constructor(accordion) {
        /**
         * @type {{}}
         */
        this.config = {
            duration: 400
        };
        /**
         * @type Element
         */
        this.accordion = accordion;
        /**
         * @type {Element}
         */
        this.heading = this.accordion.querySelector('.heading');
        /**
         * @type {Element}
         */
        this.panel = this.accordion.querySelector('.panel');
        /**
         * @type {NodeListOf<HTMLElementTagNameMap[[string]]> | NodeListOf<Element> | NodeListOf<SVGElementTagNameMap[[string]]>}
         */
        this.images = this.panel.querySelectorAll('img');
        /**
         * @type {number}
         */
        this.totalImages = this.images.length;
        /**
         * @type {number}
         */
        this.counterImageLoaded = 0;
        /**
         * Init
         */
        this._init();
    }

    /**
     * init
     * @private
     */
    _init() {
        this._loadImage();
        this.panel.style.transition = 'max-height ' + this.config.duration / 1000 + 's';
    }

    /**
     * Load
     * @private
     */
    _loadImage() {
        if (this.counterImageLoaded === 0) {
            this.heading.classList.add('loading');
        }

        if (this.counterImageLoaded < this.totalImages) {
            const IMG = new Image();

            IMG.onload = () => {
                this.counterImageLoaded++;
                this._loadImage();
            };

            IMG.onerror = () => {
                this.counterImageLoaded++;
                this._loadImage();
            };

            IMG.src = this.images[this.counterImageLoaded].src;

        } else {
            this.heading.classList.remove('loading');
            return this._onReady()
        }
    }

    /**
     * On ready
     * @private
     */
    _onReady() {
        this.heading.addEventListener('click', () => this.toggle());

        // Check if accordion is open native
        if (this.accordion.classList.contains('open')) {
            this.panel.style.maxHeight = this.panel.scrollHeight + "px";
        }
        // If anchor
        if (window.location.hash.split('#')[1] === this.accordion.id) {
            this.panel.style.maxHeight = this.panel.scrollHeight + "px";
            this.accordion.classList.add("open");
        }
    }

    /**
     * Click heading accordion
     */
    toggle() {
        if (this.panel.style.maxHeight) { // Close
            Accordion.setPanelHeight(this.panel, true);
        } else { // Open
            Accordion.closeAll();
            Accordion.setPanelHeight(this.panel);

            // Smooth scroll accordion top
            setTimeout(() => {
                new SmoothScroll(this.heading, {
                    threshold: -58
                })
            }, this.config.duration);
        }

        this.accordion.classList.toggle("open");
    }

    /**
     * Close all accordion
     */
    static closeAll() {
        const accordions = document.querySelectorAll('.accordion');

        for (let i = 0; i < accordions.length; i++) {
            accordions[i].querySelector('.panel').style.maxHeight = null;
            accordions[i].classList.remove('open')
        }
    }

    /**
     * Set accordion height
     * @param accordion
     * @param reset
     */
    static setPanelHeight(accordion, reset) {
        accordion.style.maxHeight = (reset) ? null : accordion.scrollHeight + 'px';
    }

}